import api from './api'; // tu instancia de axios

export const getVentasResumen = async (params) => {
    try {
        const response = await api.get('dashboard/ventas/filter/', { params });
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: 'Error al obtener datos de ventas' };
    }
};



export const getProductInventoryMaximium = async (params) => {
    try {
        const response = await api.get('dashboard/product-max/filter/', { params });
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: 'Error al obtener datos de ventas' };
    }
};


export const getProductInventoryMinimium = async (params) => {
    try {
        const response = await api.get('dashboard/product-min/filter/', { params });
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: 'Error al obtener datos de ventas' };
    }
};


export const getTopSellingProducts = async (params) => {
  try {
    const response = await api.get("dashboard/top-products/filter/", { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Error al obtener productos más vendidos" };
  }
};
